import React, { useState } from 'react';
import GmModal from 'app/shared/modal/modal';
import { MultiSelect } from 'app/shared/select';
import AddMailboxModal from 'app/shared/add-mailbox-modal';
import { SimpleInput } from 'app/shared/input';
import { Icon } from 'assets/icons';
import { Checkbox } from 'app/shared/input/checkbox';
import { DetailItem } from 'app/shared/info-section/item';
import { GridColumn, GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import styles from './sidebar.module.css';

export const SidebarForm = ({
  transactional,
  mailbox,
  onChange,
  errors,
  onSave,
  is_saving,
  is_save_disabled
}) => {
  const [show_add_mailbox_modal, setShowAddMailboxModal] = useState(false);

  const handleMailboxAdded = (email) => {
    mailbox.emails.push(email);
  };

  const handleItemSelection = (key) => {
    onChange(key, !transactional[key]);
  };

  return (
    <div className={styles.formWrapper}>
      <div className={styles.fields}>
        {/* Title + Code */}
        <div className={styles.group}>
          <DetailItem title="Title" required>
            <SimpleInput
              className={styles.textInput}
              wrapperClassName={styles.formGroup}
              id="transactional_title"
              type="text"
              value={transactional.title}
              onInput={(e) => onChange('title', e)}
              error={errors.title}
            />
          </DetailItem>
          <DetailItem title="Code">
            <SimpleInput
              className={styles.textInput}
              wrapperClassName={styles.formGroup}
              id="transactional_code"
              type="text"
              value={transactional.code}
              onInput={(e) => onChange('code', e)}
              error={errors.code}
            />
          </DetailItem>
        </div>

        <div className={styles.group}>
          <DetailItem title="Preview text">
            <SimpleInput
              className={styles.textInput}
              wrapperClassName={styles.formGroup}
              input_id="transactional_preview_text"
              value={transactional.preview_text}
              onInput={(e) => onChange('preview_text', e)}
            />
          </DetailItem>
        </div>

        {/* Sender */}
        <div className={styles.group}>
          <GridRow num_of_columns={5}>
            <GridColumn span={2}>
              <DetailItem title="Sender Name" required>
                <SimpleInput
                  className={styles.textInput}
                  wrapperClassName={styles.formGroup}
                  id="sender_name"
                  value={transactional.sender_name}
                  onInput={(e) => onChange('sender_name', e)}
                  error={errors.sender_name}
                />
              </DetailItem>
            </GridColumn>
            <GridColumn span={3}>
              <DetailItem title="Sender Email" required>
                <div className={styles.senderEmailInputRow}>
                  <div className={styles.senderEmailSelect}>
                    <MultiSelect
                      options={(mailbox.emails || []).map((email) => ({
                        label: email,
                        value: email
                      }))}
                      onChange={(v) => onChange('sender_email', v.value)}
                      value={{
                        value: transactional.sender_email,
                        label: transactional.sender_email
                      }}
                      error={errors.sender_email}
                      className={styles.noMargin}
                    />
                  </div>
                  <button
                    className={styles.addEmailBtn}
                    onClick={() => setShowAddMailboxModal(true)}
                    type="button"
                    title="Add sender email"
                  >
                    <Icon name="add_circle" width={16} height={16} />
                  </button>
                </div>
              </DetailItem>
            </GridColumn>
          </GridRow>
        </div>

        {/* Options */}
        <div className={styles.group}>
          <Checkbox
            checked={transactional?.retry_email}
            input_id="retry_email"
            label="Retry emails on failure"
            onClick={() => handleItemSelection('retry_email')}
          />
          <Checkbox
            checked={transactional?.is_marketer_managed}
            input_id="is_marketer_managed"
            label="Marketer controls content"
            onClick={() => handleItemSelection('is_marketer_managed')}
          />
        </div>
      </div>

      {/* Save button */}
      <div className={styles.submitForm}>
        <Button
          className={styles.sendButton}
          onClick={onSave}
          disabled={is_save_disabled}
          loading={is_saving}
          text="Save Transactional"
        />
      </div>

      <GmModal
        title="Add sender email"
        show_title={true}
        show_modal={show_add_mailbox_modal}
        onClose={() => setShowAddMailboxModal(false)}
      >
        <AddMailboxModal mailbox={mailbox} onSuccess={handleMailboxAdded} />
      </GmModal>
    </div>
  );
};
